export interface MediaState {
  MediaFormEvent: {valid: boolean;
  elementVisual: any;
  dataTosaveVisual: any;
  index: number;
  docpath: string;
  messageType: string; // évite le mot réservé `type`
  action: any; } | null;
  }
export const initialMediaState: MediaState = {
 MediaFormEvent: null
};

